import { render, staticRenderFns } from "./VNavigator.vue?vue&type=template&id=17f87fd0&scoped=true&"
import script from "./VNavigator.vue?vue&type=script&lang=ts&"
export * from "./VNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./VNavigator.vue?vue&type=style&index=0&id=17f87fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f87fd0",
  null
  
)

export default component.exports